<template>
  <div class="container">
    <div class="level"></div>
    <div class="row container flex">
      <figure class="image container">
        <img
          :src="value"
          v-img-fallback="imgFallback"
          class="m-auto is-rounded is-pink"
          style="border: solid;"
        />
        <avatar-cropper
          trigger="#pick-avatar"
          :upload-url="
            `https://phi87a8msl.execute-api.eu-west-1.amazonaws.com/default/Ecobanka-S3PresignedUpload?fileName=${file.name}`
          "
          @uploading="handleUploading"
          @changed="handleChanged"
          @completed="handleCompleted"
          @error="handlerError"
          :labels="{ submit: $t('Aceptar'), cancel: $t('Cancelar') }"
        />
        <b-button
          native-type="submit"
          type="is-pink"
          id="pick-avatar"
          class="level-right"
          >{{ $t('Selecciona una imagen') }}</b-button
        >
      </figure>
    </div>
  </div>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper'
import { ImgFallback } from 'v-img-fallback'

function xmlToJson(xml) {
  var obj = {}

  if (xml.nodeType == 1) {
    if (xml.attributes.length > 0) {
      obj['@attributes'] = {}
      for (var j = 0; j < xml.attributes.length; j++) {
        var attribute = xml.attributes.item(j)
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue
      }
    }
  } else if (xml.nodeType == 3) {
    // text
    obj = xml.nodeValue
  }

  // do children
  if (xml.hasChildNodes()) {
    for (var i = 0; i < xml.childNodes.length; i++) {
      var item = xml.childNodes.item(i)
      var nodeName = item.nodeName
      if (typeof obj[nodeName] == 'undefined') {
        obj[nodeName] = xmlToJson(item)
      } else {
        if (typeof obj[nodeName].push == 'undefined') {
          var old = obj[nodeName]
          obj[nodeName] = []
          obj[nodeName].push(old)
        }
        obj[nodeName].push(xmlToJson(item))
      }
    }
  }
  return obj
}
export default {
  components: { AvatarCropper },
  props: ['value'],
  data() {
    return {
      file: {},
      imgFallback: {
        error:
          'https://icon-library.com/images/default-user-icon/default-user-icon-4.jpg'
      }
    }
  },
  directives: {
    ImgFallback
  },
  methods: {
    handleUploading(form) {
      this.file = form.get('file')
      form.append('name', this.file.name)
      form.append('type', this.file.type)
    },
    handleChanged(file) {
      this.file = file
    },
    handleCompleted(response) {
      let self = this
      this.uploadFileToS3(response, this.file)
        .then(response => response.responseText)
        .then(str => new window.DOMParser().parseFromString(str, 'text/xml'))
        .then(data => {
          const resp = xmlToJson(data)
          self.userAvatar = resp['PostResponse']['Location']['#text']
          self.$emit('input', resp['PostResponse']['Location']['#text'])
        })
    },
    handlerError(message, type) {
      if (type == 'upload') {
        console.log('handlerError')
      }
    },
    uploadFileToS3(presignedPostData, file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        Object.keys(presignedPostData.signature).forEach(key => {
          formData.append(key, presignedPostData.signature[key])
        })

        formData.append('file', file)

        const xhr = new XMLHttpRequest()

        xhr.open('POST', presignedPostData.postEndpoint, true)
        xhr.setRequestHeader('Accept', '*/*')
        xhr.send(formData)
        xhr.onload = function() {
          this.status === 201 ? resolve(this) : reject(this.responseText)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
figure.image {
  height: 180px;
  width: 180px;
}
</style>
